import * as React from 'react';

const iconMap = {
    // GENERIC
    star: /*#__PURE__*/ React.lazy(()=>import('./static/generic/star.svg.js')
    ),
    qrScan: /*#__PURE__*/ React.lazy(()=>import('./static/generic/qr-code-scan.svg.js')
    ),
    // COMMERCE
    'address-book': /*#__PURE__*/ React.lazy(()=>import('./static/contact/address-book.svg.js')
    ),
    'add-to-cart': /*#__PURE__*/ React.lazy(()=>import('./static/commerce/add-to-cart.svg.js')
    ),
    astigmatism: /*#__PURE__*/ React.lazy(()=>import('./static/commerce/astigmatism.svg.js')
    ),
    business: /*#__PURE__*/ React.lazy(()=>import('./static/commerce/business.svg.js')
    ),
    'calendar-monthly': /*#__PURE__*/ React.lazy(()=>import('./static/commerce/calendar-monthly.svg.js')
    ),
    'calendar-quarterly': /*#__PURE__*/ React.lazy(()=>import('./static/commerce/calendar-quarterly.svg.js')
    ),
    'card-payment': /*#__PURE__*/ React.lazy(()=>import('./static/commerce/card-payment.svg.js')
    ),
    'cash-payment': /*#__PURE__*/ React.lazy(()=>import('./static/commerce/cash-payment.svg.js')
    ),
    'credit-card': /*#__PURE__*/ React.lazy(()=>import('./static/commerce/credit-card.svg.js')
    ),
    delivery: /*#__PURE__*/ React.lazy(()=>import('./static/commerce/delivery.svg.js')
    ),
    'discount-bubble': /*#__PURE__*/ React.lazy(()=>import('./static/commerce/discount-bubble.svg.js')
    ),
    discount: /*#__PURE__*/ React.lazy(()=>import('./static/commerce/discount.svg.js')
    ),
    'eye-test': /*#__PURE__*/ React.lazy(()=>import('./static/commerce/eye-test.svg.js')
    ),
    'eye-test-alt': /*#__PURE__*/ React.lazy(()=>import('./static/commerce/eye-test-alt.svg.js')
    ),
    'favourite-empty': /*#__PURE__*/ React.lazy(()=>import('./static/commerce/favourite-empty.svg.js')
    ),
    'favourite-filled': /*#__PURE__*/ React.lazy(()=>import('./static/commerce/favourite-filled.svg.js')
    ),
    'for-baby': /*#__PURE__*/ React.lazy(()=>import('./static/commerce/for-baby.svg.js')
    ),
    'for-dry-eyes': /*#__PURE__*/ React.lazy(()=>import('./static/commerce/for-dry-eyes.svg.js')
    ),
    'for-kids': /*#__PURE__*/ React.lazy(()=>import('./static/commerce/for-kids.svg.js')
    ),
    'last-chance': /*#__PURE__*/ React.lazy(()=>import('./static/commerce/last-chance.svg.js')
    ),
    'seen-on-tv': /*#__PURE__*/ React.lazy(()=>import('./static/commerce/seen-on-tv.svg.js')
    ),
    'three-d-printed': /*#__PURE__*/ React.lazy(()=>import('./static/commerce/three-d-printed.svg.js')
    ),
    trendy: /*#__PURE__*/ React.lazy(()=>import('./static/commerce/trendy.svg.js')
    ),
    'happy-computer': /*#__PURE__*/ React.lazy(()=>import('./static/commerce/happy-computer.svg.js')
    ),
    'iris-scan': /*#__PURE__*/ React.lazy(()=>import('./static/commerce/iris-scan.svg.js')
    ),
    return: /*#__PURE__*/ React.lazy(()=>import('./static/commerce/returns.svg.js')
    ),
    returns: /*#__PURE__*/ React.lazy(()=>import('./static/commerce/returns.svg.js')
    ),
    'returns-alt': /*#__PURE__*/ React.lazy(()=>import('./static/commerce/returns-alt.svg.js')
    ),
    'shopping-bag': /*#__PURE__*/ React.lazy(()=>import('./static/commerce/shopping-bag.svg.js')
    ),
    'shopping-bag-alt': /*#__PURE__*/ React.lazy(()=>import('./static/commerce/shopping-bag-alt.svg.js')
    ),
    'shop-assistant': /*#__PURE__*/ React.lazy(()=>import('./static/commerce/shop-assistant.svg.js')
    ),
    store: /*#__PURE__*/ React.lazy(()=>import('./static/commerce/store.svg.js')
    ),
    truck: /*#__PURE__*/ React.lazy(()=>import('./static/commerce/truck.svg.js')
    ),
    'left-eye': /*#__PURE__*/ React.lazy(()=>import('./static/commerce/left-eye.svg.js')
    ),
    'right-eye': /*#__PURE__*/ React.lazy(()=>import('./static/commerce/right-eye.svg.js')
    ),
    printer: /*#__PURE__*/ React.lazy(()=>import('./static/commerce/printer.svg.js')
    ),
    'new-collection': /*#__PURE__*/ React.lazy(()=>import('./static/commerce/new-collection.svg.js')
    ),
    'blue-light-filter': /*#__PURE__*/ React.lazy(()=>import('./static/commerce/blue-light-filter.svg.js')
    ),
    sustainable: /*#__PURE__*/ React.lazy(()=>import('./static/commerce/sustainable.svg.js')
    ),
    'polarised-glasses': /*#__PURE__*/ React.lazy(()=>import('./static/commerce/polarised-glasses.svg.js')
    ),
    'shopping-basket-star': /*#__PURE__*/ React.lazy(()=>import('./static/commerce/shopping-basket-star.svg.js')
    ),
    billing: /*#__PURE__*/ React.lazy(()=>import('./static/commerce/billing.svg.js')
    ),
    company: /*#__PURE__*/ React.lazy(()=>import('./static/commerce/company.svg.js')
    ),
    newsletter: /*#__PURE__*/ React.lazy(()=>import('./static/commerce/newsletter.svg.js')
    ),
    'smart-glasses': /*#__PURE__*/ React.lazy(()=>import('./static/commerce/smart-glasses.svg.js')
    ),
    // CONTACT
    calendar: /*#__PURE__*/ React.lazy(()=>import('./static/contact/calendar.svg.js')
    ),
    location: /*#__PURE__*/ React.lazy(()=>import('./static/contact/location.svg.js')
    ),
    mail: /*#__PURE__*/ React.lazy(()=>import('./static/contact/mail.svg.js')
    ),
    'mail-with-circle': /*#__PURE__*/ React.lazy(()=>import('./static/contact/mail-with-circle.svg.js')
    ),
    phone: /*#__PURE__*/ React.lazy(()=>import('./static/contact/phone.svg.js')
    ),
    'phone-with-cord': /*#__PURE__*/ React.lazy(()=>import('./static/contact/phone-with-cord.svg.js')
    ),
    warranty: /*#__PURE__*/ React.lazy(()=>import('./static/commerce/warranty.svg.js')
    ),
    // FACE SHAPES
    'face-shape-diamond': /*#__PURE__*/ React.lazy(()=>import('./static/face-shapes/diamond.svg.js')
    ),
    'face-shape-heart': /*#__PURE__*/ React.lazy(()=>import('./static/face-shapes/heart.svg.js')
    ),
    'face-shape-oval': /*#__PURE__*/ React.lazy(()=>import('./static/face-shapes/oval.svg.js')
    ),
    'face-shape-rectangular': /*#__PURE__*/ React.lazy(()=>import('./static/face-shapes/rectangular.svg.js')
    ),
    'face-shape-round': /*#__PURE__*/ React.lazy(()=>import('./static/face-shapes/round.svg.js')
    ),
    'face-shape-square': /*#__PURE__*/ React.lazy(()=>import('./static/face-shapes/square.svg.js')
    ),
    // FRAME SHAPES
    'frame-shape-almond': /*#__PURE__*/ React.lazy(()=>import('./static/frame-shapes/almond.svg.js')
    ),
    'frame-shape-aviator': /*#__PURE__*/ React.lazy(()=>import('./static/frame-shapes/aviator.svg.js')
    ),
    'frame-shape-cat-eye': /*#__PURE__*/ React.lazy(()=>import('./static/frame-shapes/cat-eye.svg.js')
    ),
    'frame-shape-hexagon': /*#__PURE__*/ React.lazy(()=>import('./static/frame-shapes/hexagon.svg.js')
    ),
    'frame-shape-irregular': /*#__PURE__*/ React.lazy(()=>import('./static/frame-shapes/irregular.svg.js')
    ),
    'frame-shape-mask': /*#__PURE__*/ React.lazy(()=>import('./static/frame-shapes/mask.svg.js')
    ),
    'frame-shape-oval': /*#__PURE__*/ React.lazy(()=>import('./static/frame-shapes/oval.svg.js')
    ),
    'frame-shape-rectangle': /*#__PURE__*/ React.lazy(()=>import('./static/frame-shapes/rectangle.svg.js')
    ),
    'frame-shape-rectangle-square': /*#__PURE__*/ React.lazy(()=>import('./static/frame-shapes/rectangle-square.svg.js')
    ),
    'frame-shape-round': /*#__PURE__*/ React.lazy(()=>import('./static/frame-shapes/round.svg.js')
    ),
    'frame-shape-sporty': /*#__PURE__*/ React.lazy(()=>import('./static/frame-shapes/sporty.svg.js')
    ),
    'frame-shape-square': /*#__PURE__*/ React.lazy(()=>import('./static/frame-shapes/square.svg.js')
    ),
    'frame-shape-round-oval': /*#__PURE__*/ React.lazy(()=>import('./static/frame-shapes/round-oval.svg.js')
    ),
    'frame-shape-panto': /*#__PURE__*/ React.lazy(()=>import('./static/frame-shapes/panto.svg.js')
    ),
    // GLASSES
    'glasses-broken': /*#__PURE__*/ React.lazy(()=>import('./static/glasses/glasses-broken.svg.js')
    ),
    glasses: /*#__PURE__*/ React.lazy(()=>import('./static/glasses/glasses.svg.js')
    ),
    'glasses-retro': /*#__PURE__*/ React.lazy(()=>import('./static/glasses/glasses-retro.svg.js')
    ),
    'glasses-futuristic': /*#__PURE__*/ React.lazy(()=>import('./static/glasses/glasses-futuristic.svg.js')
    ),
    sunglasses: /*#__PURE__*/ React.lazy(()=>import('./static/glasses/sunglasses.svg.js')
    ),
    // INTERFACE
    'alert-circle': /*#__PURE__*/ React.lazy(()=>import('./static/interface/alert-circle.svg.js')
    ),
    'chevron-down': /*#__PURE__*/ React.lazy(()=>import('./static/interface/chevron/chevron-down.svg.js')
    ),
    'chevron-left': /*#__PURE__*/ React.lazy(()=>import('./static/interface/chevron/chevron-left.svg.js')
    ),
    'chevron-right': /*#__PURE__*/ React.lazy(()=>import('./static/interface/chevron/chevron-right.svg.js')
    ),
    'chevron-up': /*#__PURE__*/ React.lazy(()=>import('./static/interface/chevron/chevron-up.svg.js')
    ),
    checklist: /*#__PURE__*/ React.lazy(()=>import('./static/interface/checklist.svg.js')
    ),
    checkmark: /*#__PURE__*/ React.lazy(()=>import('./static/interface/checkmark.svg.js')
    ),
    'checkmark-circle': /*#__PURE__*/ React.lazy(()=>import('./static/interface/checkmark-circle.svg.js')
    ),
    clock: /*#__PURE__*/ React.lazy(()=>import('./static/interface/clock.svg.js')
    ),
    close: /*#__PURE__*/ React.lazy(()=>import('./static/interface/close.svg.js')
    ),
    content: /*#__PURE__*/ React.lazy(()=>import('./static/interface/content.svg.js')
    ),
    clear: /*#__PURE__*/ React.lazy(()=>import('./static/interface/clear.svg.js')
    ),
    'double-chevron-left': /*#__PURE__*/ React.lazy(()=>import('./static/interface/chevron/double-chevron-left.svg.js')
    ),
    'double-chevron-right': /*#__PURE__*/ React.lazy(()=>import('./static/interface/chevron/double-chevron-right.svg.js')
    ),
    dots: /*#__PURE__*/ React.lazy(()=>import('./static/interface/dots.svg.js')
    ),
    driving: /*#__PURE__*/ React.lazy(()=>import('./static/interface/driving.svg.js')
    ),
    eye: /*#__PURE__*/ React.lazy(()=>import('./static/interface/eye.svg.js')
    ),
    'eye-slash': /*#__PURE__*/ React.lazy(()=>import('./static/interface/eye-slash.svg.js')
    ),
    filter: /*#__PURE__*/ React.lazy(()=>import('./static/interface/filter.svg.js')
    ),
    gps: /*#__PURE__*/ React.lazy(()=>import('./static/interface/gps.svg.js')
    ),
    hamburger: /*#__PURE__*/ React.lazy(()=>import('./static/interface/hamburger.svg.js')
    ),
    info: /*#__PURE__*/ React.lazy(()=>import('./static/interface/info.svg.js')
    ),
    'information-circle': /*#__PURE__*/ React.lazy(()=>import('./static/interface/information-circle.svg.js')
    ),
    letter: /*#__PURE__*/ React.lazy(()=>import('./static/interface/letter.svg.js')
    ),
    list: /*#__PURE__*/ React.lazy(()=>import('./static/interface/list.svg.js')
    ),
    'location-current': /*#__PURE__*/ React.lazy(()=>import('./static/interface/location-current.svg.js')
    ),
    'location-pin': /*#__PURE__*/ React.lazy(()=>import('./static/interface/location-pin.svg.js')
    ),
    minus: /*#__PURE__*/ React.lazy(()=>import('./static/interface/minus.svg.js')
    ),
    pause: /*#__PURE__*/ React.lazy(()=>import('./static/interface/pause.svg.js')
    ),
    paperclip: /*#__PURE__*/ React.lazy(()=>import('./static/upload/paperclip.svg.js')
    ),
    pencil: /*#__PURE__*/ React.lazy(()=>import('./static/interface/pencil.svg.js')
    ),
    plus: /*#__PURE__*/ React.lazy(()=>import('./static/interface/plus.svg.js')
    ),
    play: /*#__PURE__*/ React.lazy(()=>import('./static/interface/play.svg.js')
    ),
    questionmark: /*#__PURE__*/ React.lazy(()=>import('./static/interface/questionmark.svg.js')
    ),
    search: /*#__PURE__*/ React.lazy(()=>import('./static/interface/search.svg.js')
    ),
    share: /*#__PURE__*/ React.lazy(()=>import('./static/interface/share.svg.js')
    ),
    sheet: /*#__PURE__*/ React.lazy(()=>import('./static/interface/sheet.svg.js')
    ),
    tools: /*#__PURE__*/ React.lazy(()=>import('./static/interface/tools.svg.js')
    ),
    trash: /*#__PURE__*/ React.lazy(()=>import('./static/interface/trash.svg.js')
    ),
    user: /*#__PURE__*/ React.lazy(()=>import('./static/interface/user.svg.js')
    ),
    'user-search': /*#__PURE__*/ React.lazy(()=>import('./static/interface/user-search.svg.js')
    ),
    walking: /*#__PURE__*/ React.lazy(()=>import('./static/interface/walking.svg.js')
    ),
    warning: /*#__PURE__*/ React.lazy(()=>import('./static/interface/warning.svg.js')
    ),
    wheelchair: /*#__PURE__*/ React.lazy(()=>import('./static/interface/wheelchair.svg.js')
    ),
    // LENSES
    lens: /*#__PURE__*/ React.lazy(()=>import('./static/lenses/lens.svg.js')
    ),
    solution: /*#__PURE__*/ React.lazy(()=>import('./static/lenses/solution.svg.js')
    ),
    // MY ACCOUNT
    frame: /*#__PURE__*/ React.lazy(()=>import('./static/my-account/frame.svg.js')
    ),
    lock: /*#__PURE__*/ React.lazy(()=>import('./static/my-account/lock.svg.js')
    ),
    logout: /*#__PURE__*/ React.lazy(()=>import('./static/my-account/logout.svg.js')
    ),
    orders: /*#__PURE__*/ React.lazy(()=>import('./static/my-account/orders.svg.js')
    ),
    'folded-page-with-text': /*#__PURE__*/ React.lazy(()=>import('./static/my-account/folded-page-with-text.svg.js')
    ),
    reschedule: /*#__PURE__*/ React.lazy(()=>import('./static/my-account/reschedule.svg.js')
    ),
    'shipment-next': /*#__PURE__*/ React.lazy(()=>import('./static/my-account/shipment-next.svg.js')
    ),
    'user-checkmark': /*#__PURE__*/ React.lazy(()=>import('./static/my-account/user-checkmark.svg.js')
    ),
    'social-apple': /*#__PURE__*/ React.lazy(()=>import('./static/my-account/social-apple.svg.js')
    ),
    'social-google': /*#__PURE__*/ React.lazy(()=>import('./static/my-account/social-google.svg.js')
    ),
    // PRESCRIPTION
    'store-eye-test': /*#__PURE__*/ React.lazy(()=>import('./static/prescription/store-eye-test.svg.js')
    ),
    // PRODUCTS
    '360-deg': /*#__PURE__*/ React.lazy(()=>import('./static/products/360-deg.svg.js')
    ),
    'try-on': /*#__PURE__*/ React.lazy(()=>import('./static/products/try-on.svg.js')
    ),
    // UPLOAD
    'upload-prescription': /*#__PURE__*/ React.lazy(()=>import('./static/upload/upload-prescription.svg.js')
    ),
    'upload-pd': /*#__PURE__*/ React.lazy(()=>import('./static/upload/upload-pd.svg.js')
    ),
    // APPOINTMENTS
    'calendar-time': /*#__PURE__*/ React.lazy(()=>import('./static/appointments/calendar-time.svg.js')
    ),
    'chat-bubble': /*#__PURE__*/ React.lazy(()=>import('./static/appointments/chat-bubble.svg.js')
    ),
    'child-appointment': /*#__PURE__*/ React.lazy(()=>import('./static/appointments/child-appointment.svg.js')
    ),
    'hearing-test': /*#__PURE__*/ React.lazy(()=>import('./static/appointments/hearing-test.svg.js')
    ),
    repairs: /*#__PURE__*/ React.lazy(()=>import('./static/appointments/repairs.svg.js')
    ),
    'eye-test-contact-lens': /*#__PURE__*/ React.lazy(()=>import('./static/appointments/eye-test-contact-lens.svg.js')
    ),
    'eye-test-drivers': /*#__PURE__*/ React.lazy(()=>import('./static/appointments/eye-test-drivers.svg.js')
    ),
    'eye-test-glasses': /*#__PURE__*/ React.lazy(()=>import('./static/appointments/eye-test-glasses.svg.js')
    ),
    'eye-test-medical-card': /*#__PURE__*/ React.lazy(()=>import('./static/appointments/eye-test-medical-card.svg.js')
    ),
    megaphone: /*#__PURE__*/ React.lazy(()=>import('./static/appointments/megaphone.svg.js')
    ),
    'sunglasses-retro': /*#__PURE__*/ React.lazy(()=>import('./static/appointments/sunglasses-retro.svg.js')
    ),
    'video-call': /*#__PURE__*/ React.lazy(()=>import('./static/appointments/video-call.svg.js')
    ),
    // PAYMENT METHODS
    amex: /*#__PURE__*/ React.lazy(()=>import('./static/payment-methods/amex.svg.js')
    ),
    bancontact: /*#__PURE__*/ React.lazy(()=>import('./static/payment-methods/bancontact.svg.js')
    ),
    'cash-on-delivery': /*#__PURE__*/ React.lazy(()=>import('./static/payment-methods/cash-on-delivery.svg.js')
    ),
    dankort: /*#__PURE__*/ React.lazy(()=>import('./static/payment-methods/dankort.svg.js')
    ),
    ideal: /*#__PURE__*/ React.lazy(()=>import('./static/payment-methods/ideal.svg.js')
    ),
    klarna: /*#__PURE__*/ React.lazy(()=>import('./static/payment-methods/klarna.svg.js')
    ),
    maestro: /*#__PURE__*/ React.lazy(()=>import('./static/payment-methods/maestro.svg.js')
    ),
    mastercard: /*#__PURE__*/ React.lazy(()=>import('./static/payment-methods/mastercard.svg.js')
    ),
    mbway: /*#__PURE__*/ React.lazy(()=>import('./static/payment-methods/mbway.svg.js')
    ),
    mobilepay: /*#__PURE__*/ React.lazy(()=>import('./static/payment-methods/mobilepay.svg.js')
    ),
    multibanco: /*#__PURE__*/ React.lazy(()=>import('./static/payment-methods/multibanco.svg.js')
    ),
    oney: /*#__PURE__*/ React.lazy(()=>import('./static/payment-methods/oney.svg.js')
    ),
    paypal: /*#__PURE__*/ React.lazy(()=>import('./static/payment-methods/paypal.svg.js')
    ),
    sepa: /*#__PURE__*/ React.lazy(()=>import('./static/payment-methods/sepa.svg.js')
    ),
    swish: /*#__PURE__*/ React.lazy(()=>import('./static/payment-methods/swish.svg.js')
    ),
    visa: /*#__PURE__*/ React.lazy(()=>import('./static/payment-methods/visa.svg.js')
    ),
    'apple-checkout-button-icon': /*#__PURE__*/ React.lazy(()=>import('./static/payment-methods/apple-checkout-button-icon.svg.js')
    ),
    'paypal-checkout-button-icon': /*#__PURE__*/ React.lazy(()=>import('./static/payment-methods/paypal-checkout-button-icon.svg.js')
    ),
    apple: /*#__PURE__*/ React.lazy(()=>import('./static/payment-methods/apple.svg.js')
    ),
    //BANK ICONS
    asn: /*#__PURE__*/ React.lazy(()=>import('./static/bank-icons/asn.svg.js')
    ),
    bunq: /*#__PURE__*/ React.lazy(()=>import('./static/bank-icons/bunq.svg.js')
    ),
    knab: /*#__PURE__*/ React.lazy(()=>import('./static/bank-icons/knab.svg.js')
    ),
    rabo: /*#__PURE__*/ React.lazy(()=>import('./static/bank-icons/rabo.svg.js')
    ),
    regio: /*#__PURE__*/ React.lazy(()=>import('./static/bank-icons/regio.svg.js')
    ),
    revolut: /*#__PURE__*/ React.lazy(()=>import('./static/bank-icons/revolut.svg.js')
    ),
    triodos: /*#__PURE__*/ React.lazy(()=>import('./static/bank-icons/triodos.svg.js')
    ),
    vanLanschot: /*#__PURE__*/ React.lazy(()=>import('./static/bank-icons/van-lanschot.svg.js')
    ),
    abn: /*#__PURE__*/ React.lazy(()=>import('./static/bank-icons/abn.svg.js')
    ),
    ing: /*#__PURE__*/ React.lazy(()=>import('./static/bank-icons/ing.svg.js')
    ),
    sns: /*#__PURE__*/ React.lazy(()=>import('./static/bank-icons/sns.svg.js')
    ),
    abnAmro: /*#__PURE__*/ React.lazy(()=>import('./static/bank-icons/abn-amro.svg.js')
    ),
    yourSafe: /*#__PURE__*/ React.lazy(()=>import('./static/bank-icons/your-safe.svg.js')
    ),
    bank: /*#__PURE__*/ React.lazy(()=>import('./static/bank-icons/bank.svg.js')
    )
};
const iconNames = Object.keys(iconMap);
const iconExists = (name)=>iconNames.includes(name)
;
function getIconByName(name) {
    return iconMap[name];
}

export { getIconByName, iconExists, iconMap, iconNames };
//# sourceMappingURL=get-icon-by-name.js.map
